import { PaginationParams } from "./common";

export class SupplyOrder {
  orderId: number;
  createUserName: string;
  clinicId: number;
  clinicDescr: string;
  createDate: Date;
  statusCode: string;
  statusDescr: string;
  approveDate: Date;
  approveUserName: string;
  items: SupplyItem[] = [];
  itemListFormatted: string;
  createDateFormatted: string;
  approveOrderLoading: boolean;
  notes: string;
  deliveryEmail: string;
  mailSendSw: boolean;
  mailSentTimestamp: Date;
  apiSendStatusCode: string;
  apiSendStatusSw: boolean;
  labCreateSw: boolean;
  city: string;
  apiType: string;

  constructor() {}

  get isDeliveryOrder(): boolean {
    return (
      this.items && this.items.find((i) => i.itemTypeCode == "DELIVERY") != null
    );
  }

  get isBarcodeRollOrder(): boolean {
    return (
      this.items &&
      this.items.find((i) => i.itemTypeCode == "BARCODE_ROLL") != null
    );
  }
}

export class SupplyItem {
  itemTypeCode: string;
  itemDescr: string;
  qty: number;

  constructor() {}
}

export class SupplyOrderSearchParams extends PaginationParams {
  clinicId?: number;
  status?: string;
  type?: string;

  constructor() {
    super();
  }
}

export class SupplyOrderResponse {
  deliveryOrderId?: number;
  ordersCreated?: boolean;
}
